import { z } from 'zod'

export const internshipSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  status: z.enum(['all', 'ongoing', 'upcoming', 'finished']).catch('ongoing'),
  classId: z.string().optional().catch(undefined),
  programId: z.string().optional().catch(undefined),
  questionGroupId: z.string().optional().catch(undefined),
  startFrom: z.iso.date().optional().catch(undefined),
  startTill: z.iso.date().optional().catch(undefined),
  endFrom: z.iso.date().optional().catch(undefined),
  endTill: z.iso.date().optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['title', 'status', 'start', 'className', 'internCount']).catch('title'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type InternshipSearch = z.infer<typeof internshipSearchSchema>

export const defaultInternshipSearch: InternshipSearch = {
  status: 'ongoing',
  page: 1,
  pageSize: 10,
  sortBy: 'title',
  direction: 'asc',
}
